{
  "id": "campaign-057",
  "name": "Crooked Pasture II",
  "seed": "campaign:57",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......RRRRRR",
    "......RRRRRR",
    "......______",
    ".....u....cc",
    "~.uK.....y.,",
    "....~.#....,",
    "...~.~......",
    "ff..ffffffff",
    "............",
    "............",
    ".T...#.x....",
    "...T........",
    "............",
    "fffffffff..f",
    "............",
    ".....y....cc",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "dog",
      "x": 3,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 11
    },
    {
      "kind": "rabbit",
      "x": 6,
      "y": 17
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 8,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 11
    }
  ],
  "generatorVersion": 3,
  "level": 57,
  "biome": "farm",
  "par": {
    "reel": 6437,
    "push": 5747,
    "selfPropelled": 5304,
    "tractor": 5010,
    "zeroTurn": 3641,
    "fairway": 2322
  },
  "routeTries": {
    "par": {
      "reel": 22,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 2,
      "zeroTurn": 0,
      "fairway": 3
    }
  }
}
